import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { UtilHelper } from '../_helpers/util';
import { AuthenticationService } from '../services/guards/auth';
declare var toastr;

@Component({
    templateUrl: 'login.component.html',
    styleUrls: ['./login.component.css'],
    providers: [AuthenticationService]
})

export class LoginComponent implements OnInit {
    model: any = {};
    resetModel: any = {};
    loading = false;
    error = '';
    mostrarPassword = false;
    mostrarReset: boolean = true;
    emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}.\[a-z]{2,3}$";
    constructor(private router: Router, private _as: AuthenticationService) {   
        this.mostrarReset = true;
    }

    ngOnInit() {
        this._as.logout();
        this.mostrarReset = true;
    }

    login() {
        this.loading = true;
        this._as.postLogin(this.model).subscribe(
            response => {                
                let result = UtilHelper.responses(response);                
                if (result.status == 200) {
                    localStorage.setItem('u', JSON.stringify(result.data));
                    localStorage.setItem('g', result.data.gestion);
                    window.location.href = '/';
                } else if (result.status == 405) {
                    this.error = 'La cuenta no se encuentra activa.';
                    this.loading = false;
                }
                else {
                    this.error = 'Alguno de los datos proporcionados no es correcto.';
                    this.loading = false;
                }
            },
            error => { this.loading = false; this.error = 'Sucedió un error inesperado, por favor reportelo con el administrador.'; console.log('Error', error); });

    }

    showPassword() {
        this.mostrarPassword = !this.mostrarPassword;
        const passwordInput = document.getElementById('password') as HTMLInputElement;
        if (this.mostrarPassword) {
            passwordInput.type = 'text';
        } else {
            passwordInput.type = 'password';
        }
    }

    mostrarFormulario() {
        if (this.mostrarReset == true)
            this.mostrarReset = false;
        else
            this.mostrarReset = true;
        this.resetModel.email = '';
        this.error = '';
    }

    resetPassword() {
        this.loading = true;

        if ((this.resetModel.email != 'undefined') && (this.resetModel.email != '')) {
            this._as.reenviarPassword(this.resetModel).subscribe(
                response => {
                    let result = UtilHelper.responses(response);
                    if (result.status == 200) {
                        this.mostrarReset = false;
                        toastr.success(result.data);
                        this.loading = false;
                        this.error = '';
                    } else if (result.status == 201) {                        
                        this.error = result.data;
                        this.loading = false;
                        toastr.warning(result.data);
                    }
                    else {
                        this.error = 'Alguno de los datos proporcionados no es correcto.';
                        this.loading = false;
                        toastr.warning(result.data);
                    }
                },
                error => { this.loading = false; this.error = 'Sucedió un error inesperado, por favor reportelo con el administrador.'; console.log('Error', error); });

        }
    }

}
